import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const Content = styled.div`
    margin-top: 12px;
`;

export const FlexContainer = styled.div`
    @media (max-width: 769px) {
        & > * {
            margin-bottom: 20px;
            text-align: center;
        }
    }
    @media (min-width: 769px) {
        display: flex;
        flex-wrap: wrap;
    }
`;


export const Title = styled(Typography)`
    color: rgba(0, 0, 0, 0.87);
    flex: 1;
`;
